/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        customElements.get('side-panel-close')?.syncPanelState(this.container);
        if (this.container.classList.contains('active')) {
          this.container.cbmReturnFocus = button;
          this.container.querySelector('side-panel-close')?.focus({ preventScroll: true });
        }
        customElements.get('side-panel-close')?.syncScrollLock();
      });
    }
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

  }
  connectedCallback() {
    const initialize = () => {
      if (!this.isConnected) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.cbmInitObserver?.disconnect();
      if (this.cbmForm === form) return;
      this.cbmForm?.removeEventListener('input', this.debouncedOnSubmit);
      this.cbmForm = form;
      form.addEventListener('input', this.debouncedOnSubmit);
    };
    this.cbmInitObserver = new MutationObserver(initialize);
    this.cbmInitObserver.observe(this, { childList: true, subtree: true });
    queueMicrotask(initialize);
  }
  disconnectedCallback() {
    this.cbmInitObserver?.disconnect();
    this.cbmForm?.removeEventListener('input', this.debouncedOnSubmit);
    this.cbmForm = null;
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static async renderPage(searchParams, event, updateURLHash = true) {
    const F = FacetFiltersForm;
    F.request?.abort();
    const controller = new AbortController();
    F.request = controller;
    if (!F.successHTML) F.successHTML = document.documentElement.outerHTML;
    const collection = document.getElementById('ProductGridContainer').querySelector('.collection');
    collection.classList.add('loading');
    document.querySelectorAll('.thb-filter-count').forEach(item => item.classList.add('loading'));
    document.querySelector('[data-filter-error]')?.remove();
    document.dispatchEvent(new CustomEvent('collection:filter-start'));
    let timer;
    try {
      const section = F.getSections()[0].section;
      const url = `${window.location.pathname}?section_id=${section}&${searchParams}`;
      const cached = F.filterData.find(item => item.url === url);
      const html = cached ? cached.html : await Promise.race([
        fetch(url, { signal: controller.signal }).then(response => {
          if (!response.ok) throw new Error('filter-request-failed');
          return response.text();
        }),
        new Promise((resolve, reject) => { timer = setTimeout(() => {
          controller.abort(); reject(new Error('filter-request-timeout'));
        }, 8000); })
      ]);
      if (F.request !== controller) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (!parsed.getElementById('ProductGridContainer') || !parsed.getElementById('ProductCount')) throw new Error('filter-content-missing');
      F.renderProductGridContainer(html);
      F.renderFilters(html);
      F.renderProductCount(html);
      F.successHTML = html;
      F.searchParamsPrev = searchParams;
      if (!cached) F.filterData = [...F.filterData.slice(-9), { html, url }];
      if (updateURLHash) F.updateURLHash(searchParams);
      new FacetsToggle();
    } catch (error) {
      if (F.request !== controller) return;
      F.renderProductGridContainer(F.successHTML);
      F.renderFilters(F.successHTML);
      F.renderProductCount(F.successHTML);
      new FacetsToggle();
      history.replaceState({ searchParams: F.searchParamsPrev }, '',
        `${window.location.pathname}${F.searchParamsPrev ? '?' + F.searchParamsPrev : ''}`);
      const feedback = document.createElement('p');
      feedback.setAttribute('data-filter-error', '');
      feedback.setAttribute('role', 'alert');
      feedback.append('Unable to update products. Your previous results are shown. ');
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Try again';
      retry.addEventListener('click', () => F.renderPage(searchParams, null, updateURLHash));
      feedback.append(retry);
      document.getElementById('ProductGridContainer').before(feedback);
    } finally {
      clearTimeout(timer);
      if (F.request === controller) {
        F.request = null;
        document.querySelector('#ProductGridContainer .collection')?.classList.remove('loading');
        document.querySelectorAll('.thb-filter-count').forEach(item => item.classList.remove('loading'));
        F.toggleActiveFacets(false);
      }
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const form = element.closest('form');
      document.querySelectorAll(`#${form.id} collapsible-row[data-index="${element.dataset.index}"]`)
        .forEach(target => { target.innerHTML = element.innerHTML; });
    });

    const sort = parsedHTML.querySelector('#FacetFiltersForm-bar custom-select');
    const currentSort = document.querySelector('#FacetFiltersForm-bar custom-select');
    if (sort && currentSort) {
      const selected = sort.querySelector('[aria-current="true"][data-value]');
      const input = sort.querySelector('[name="sort_by"]');
      if (selected && input) input.setAttribute('value', selected.dataset.value);
      currentSort.replaceWith(sort);
    }
    const mobileSort = document.getElementById('SortByMobile');
    const sourceSort = parsedHTML.getElementById('SortByMobile');
    if (mobileSort && sourceSort) mobileSort.value = sourceSort.value;
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});


